"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.batchUpdateStore = batchUpdateStore;
exports.exportImagePreCode = exportImagePreCode;
exports.exportRechargeCode = exportRechargeCode;
exports.exportSelfPickupCode = exportSelfPickupCode;
exports.exportStoreInfo = exportStoreInfo;
exports.exportTakeawayCode = exportTakeawayCode;
exports.getAreaList = getAreaList;
exports.getBatchSettingLogById = getBatchSettingLogById;
exports.getBatchSettingLogPage = getBatchSettingLogPage;
exports.getEffectiveCityList = getEffectiveCityList;
exports.getImageUrl = getImageUrl;
exports.getInvoiceCompanyList = getInvoiceCompanyList;
exports.getRegionCityList = getRegionCityList;
exports.getRegionList = getRegionList;
exports.getStoreAllData = getStoreAllData;
exports.getStoreData = getStoreData;
exports.getStoreRegionAllData = getStoreRegionAllData;
exports.getSupplierList = getSupplierList;
exports.getTimeSlot = getTimeSlot;
exports.getshopList = getshopList;
exports.queryStore = queryStore;
exports.saveStore = saveStore;
exports.syncStore = syncStore;
exports.updateBusinessHours = updateBusinessHours;
exports.updateStore = updateStore;
exports.uploadImage = uploadImage;
require("core-js/modules/es6.string.starts-with");
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
function getshopList(query) {
  return (0, _requestPIM.default)({
    url: '/shop/page',
    method: 'get',
    params: query
  });
}
function getStoreData() {
  return (0, _requestPIM.default)({
    url: '/shop/getStoreData',
    method: 'post'
  });
}
function updateStore(data) {
  return (0, _requestPIM.default)({
    url: '/shop/update',
    method: 'post',
    data: data
  });
}
function saveStore(params) {
  return (0, _requestPIM.default)({
    url: '/shop/save',
    method: 'post',
    data: params
  });
}
function getRegionList(data) {
  return (0, _requestPIM.default)({
    url: '/xyRegion/list',
    method: 'get',
    params: data
  });
}
function getRegionCityList(data) {
  return (0, _requestPIM.default)({
    url: '/xyRegion/cityList',
    method: 'get',
    params: data
  });
}
function getEffectiveCityList(data) {
  return (0, _requestPIM.default)({
    url: '/xyRegion/effectiveCityList',
    method: 'get',
    params: data
  });
}
function getTimeSlot() {
  return (0, _requestPIM.default)({
    url: '/xyTimeSlot/timeSlotList',
    method: 'get'
  });
}
function getAreaList(data) {
  return (0, _requestPIM.default)({
    url: '/xyArea/areaList',
    method: 'get',
    params: data
  });
}
function getSupplierList(data) {
  return (0, _requestPIM.default)({
    url: '/xyBrand/list',
    method: 'get',
    params: data
  });
}
function getInvoiceCompanyList(data) {
  return (0, _requestPIM.default)({
    url: '/xyInvoiceCompany/list',
    method: 'get',
    params: data
  });
}
function queryStore(data) {
  return (0, _requestPIM.default)({
    url: '/shop/getStoreTreeData',
    method: 'post',
    data: data
  });
}
function batchUpdateStore(params) {
  return (0, _requestPIM.default)({
    url: '/shop/batchUpdateStore',
    method: 'post',
    data: params
  });
}
function exportRechargeCode(params) {
  return (0, _requestPIM.default)({
    url: '/shop/exportRechargeCode',
    method: 'post',
    data: params
  });
}
function exportImagePreCode(params) {
  return (0, _requestPIM.default)({
    url: '/shop/exportImagePreCoded',
    method: 'post',
    data: params
  });
}
function exportStoreInfo(params) {
  return (0, _requestPIM.default)({
    url: '/shop/exportStoreInfo',
    method: 'post',
    data: params
  });
}
function exportTakeawayCode(params) {
  return (0, _requestPIM.default)({
    url: '/shop/exportTakeawayCode',
    method: 'post',
    data: params
  });
}
function exportSelfPickupCode(params) {
  return (0, _requestPIM.default)({
    url: '/shop/exportSelfPickupCode',
    method: 'post',
    data: params
  });
}

// 查询所有门店
function getStoreAllData() {
  return (0, _requestPIM.default)({
    url: '/shop/getStoreAllData',
    method: 'get'
  });
}

// 查询所有门店所在区域
function getStoreRegionAllData() {
  return (0, _requestPIM.default)({
    url: '/shop/getStoreRegionAllData',
    method: 'get'
  });
}

// 同步门店信息
function syncStore() {
  return (0, _requestPIM.default)({
    url: '/shop/syncStore',
    method: 'post'
  });
}
function updateBusinessHours(data) {
  return (0, _requestPIM.default)({
    url: '/shop/updateBusinessHours',
    method: 'post',
    data: data
  });
}

// 分页查询批量设置日志
function getBatchSettingLogPage(data) {
  return (0, _requestPIM.default)({
    url: '/storeBatchSettingLog/page',
    method: 'post',
    data: data
  });
}

// 根据ID查询批量设置日志详情
function getBatchSettingLogById(id) {
  return (0, _requestPIM.default)({
    url: "/storeBatchSettingLog/".concat(id),
    method: 'get'
  });
}

// 上传图片（返回相对路径）
function uploadImage(file) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/';
  var formData = new FormData();
  formData.append('file', file);
  return (0, _requestPIM.default)({
    url: '/image/upload',
    method: 'post',
    data: formData,
    params: {
      path: path
    },
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

// 数据库路径转展示URL
function getImageUrl(dbPath) {
  if (!dbPath) return '';
  if (dbPath.startsWith('http')) return dbPath;
  var prefix = '/images/mall';
  var fullPath = dbPath.startsWith(prefix) ? dbPath : prefix + dbPath;
  return process.env.VUE_APP_COMMENT_IMAGE_URL + fullPath;
}